<template>
  <div>
    <el-result :icon="getResult.icon" :title="getResult.title" :class="{ error: !isSuccess }" v-show="!loading">
      <!--<template slot="subTitle" v-if="getResult.subTitle">-->
        <!--<p>{{ getResult.subTitle }}</p>-->
        <!--<p>为您代开增值税发票</p>-->
      <!--</template>-->
      <template slot="extra">
        <div class="tips" v-if="isSuccess">
          <p>您已完成认证。如需获取开票信息，可在微信搜索”中智薪税云“，或扫描下方二维码</p>
          <p>
            通过短信验证码<img class="login-type" src="@/assets/img/mobile/login-type-code.png" />
          </p>
          <p>登录“中智薪税云”小程序查看！</p>
<!--          <p>第一时间获取开票信息！</p>-->
          <img class="miniprogram" src="@/assets/img/mobile/miniprogram.png" />
        </div>
        <div v-else>
          <van-button block round @click="reAuthLogin" color="linear-gradient(90deg, #4776F0 0%, #3062E1 100%)">重新认证</van-button>
        </div>
      </template>
    </el-result>
  </div>
</template>

<script>
  import miniprogram from '@/assets/img/mobile/miniprogram.png'
  import { validatenull } from "@/util/validate";
  import { Toast } from 'vant';
  import { urlFeedbackByTaskType } from '@/api/mobile/mobile'

  export default {
    name: "authenticationResult",
    data()  {
      return {
        result: {
          success: {
            icon: 'success',
            title: '您已通过身份认证',
            subTitle: ''
          },
          error: {
            icon: 'warning',
            title: '身份认证失败',
            subTitle: ''
          }
        },
        feedbackType: 2,         // 1-注册 2-扫脸认证
        isSuccess: false
      }
    },
    created() {
      this.isSuccess = this.$route.query.code == 1 || this.$route.query.code == 10
      if (this.isSuccess) {
        if (!validatenull(localStorage.getItem('empInfo'))) {
          const empInfo = JSON.parse(localStorage.getItem('empInfo'))
          this.result.success.subTitle = `中智薪税将协助${ empInfo.cusName }公司`
        }
        if (this.$route.query.code == 1) {
          this.getFeedbackResult() //成功才回调
        }
      }
    },
    methods: {
      // 获取认证结果
      getFeedbackResult() {
        const params = {
          urlType: this.feedbackType,
          invBaseDataId: this.getBaseDataId
        }
        urlFeedbackByTaskType(params)
          .then(res => {
          })
      },
      reAuthLogin() {
        this.$router.push({
          name: 'AuthorizationLogin'
        })
      }
    },
    computed: {
      getResult() {
        return this.isSuccess ? this.result.success : this.result.error
      },
      getBaseDataId() {
        return validatenull(localStorage.getItem('baseDataId')) ? '' : localStorage.getItem('baseDataId')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tips {
    font-weight: bold;
    margin-top: 0.3rem;
    margin-bottom: 0.5rem;
    font-size: 0.28rem;
    p {
      margin-bottom: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .login-type {
    width: 0.38rem;
    height: 0.38rem;
    margin: 0 0.06rem;
    vertical-align: middle;
  }
  .miniprogram {
    width: 3.2rem;
    height: 3.2rem;
    margin-top: 0.5rem;
  }
  .error {
    ::v-deep .el-result__extra {
      width: 50%;
    }
  }
</style>
